<template>
    <div></div>
</template>

<script>
    export default {
        name: 'app',
        data() {
            return {}
        },
        created() {
            let user = localStorage.getItem('user');
            let lang = localStorage.getItem('lang');
            if (this.isMobile()) {
                this.$router.replace('/index').catch(() => {});
            } else {
                if (lang == "" || lang == null || user == "" || user == null) {
                    localStorage.setItem("lang", 'zh')
                    this.$router.replace('/pc/index').catch(() => {});
                } else {
                    this.$router.replace('/pc/index').catch(() => {});
                }
            }
        },
        methods: {
            isMobile() {
                let flag = navigator.userAgent.match( // match方法可在字符串内检索指定的值，
                    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
                );
                return flag;
            },
        },
    }
</script>


// WEBPACK FOOTER //
// src/views/Home.vue